export enum UserType {
    ADMIN = 'admin',
    ANALYST = 'analyst',
    APPLICATION = 'application'
}
